export default __webpack_public_path__ + "static/media/img2.de8220a4.png";